import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import {
  OptionCardStyles,
  OptionCardImageStyles,
  OptionCardListStyles,
  PageStyles,
  TextStyles,
} from './Outfit.styles';

import type { LayoutDataType } from '../../types';

const OUTFIT_OPTIONS = [
  {
    id: 'jacket',
    title: 'Jacket',
    imageSrc: `${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/jacket.png`,
  },
  {
    id: 'tank-top',
    title: 'Tank Top',
    imageSrc: `${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/top-tank.png`,
  },
] as const;

export const Outfit: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Outfit Screen',
      });
    }

    preloadImage(`${S3_BUCKET_URL}/success-page/maxim/jacket.png`);
    preloadImage(`${S3_BUCKET_URL}/success-page/maxim/top-tank.png`);
  }, []);

  const form = useFormContext<LayoutDataType>();
  const outfit = form.watch('outfit');
  const { refreshUser } = useAccount();

  const handleSelect = async (optionId: string, optionTitle: string) => {
    form.setValue('outfit', optionId);
    await userService.createOrUpdate({
      onboarding_data: {
        outfit: optionTitle,
        onboarded: true,
      },
    });
    refreshUser();
  };

  return (
    <PageStyles
      background="dark-solid"
      bgImage={
        <img
          src={`${S3_BUCKET_URL}/layout-own-ai-maxim/outfit/background.png`}
          alt="Background"
        />
      }
    >
      <IonContent>
        <OptionCardListStyles>
          {OUTFIT_OPTIONS.map((option) => (
            <OptionCardStyles
              key={option.id}
              isSelected={outfit === option.id}
              onClick={() => handleSelect(option.id, option.title)}
            >
              <OptionCardImageStyles src={option.imageSrc} alt={option.title} />
            </OptionCardStyles>
          ))}
        </OptionCardListStyles>
        <TextStyles>You can also choose what I'll be wearing...</TextStyles>
      </IonContent>
    </PageStyles>
  );
};
